import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { UnitConversion, UnitOfMeasure } from '../models/UnitsOfMeasure';

export default class UnitOfMeasureApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath
    }

    public async getWarehouseUoms(measure_family_name: string): Promise<UnitOfMeasure[]> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/dictionary/units_of_measure/${measure_family_name}`, {
            params: {
                offset: 0,
                count: 300,
            }
        });
        return res.data.records;
    }

    public async getUnitConversions(): Promise<UnitConversion[]> {
        const res = await this.http.get(`${this.rootPath}/v1/services/decodes/transcode/STOCK/conversion_map`);
        return res.data;
    }

    public async getIrrigationUoms(): Promise<UnitOfMeasure[]> {
        const res = await this.http.get(`${this.rootPath}/v1/services/decodes/transcode/IRRIGA/dictionary_units_of_measure/IRRIGA`, {
            params: {
                params: 0,
                count: 300
            }
        })

        return res.data.records;
    }

    public async getDecodesUoms(measure_family_name: string): Promise<UnitOfMeasure[]> {
        const res = await this.http.get(`${this.rootPath}/v1/services/decodes/dictionary_units_of_measure/${measure_family_name}`, {
            params: {
                offset: 0,
                count: 300,
            }
        });

        return res.data.records;
    }
}
